<div class="manual-outlier-removal-wrapper fw fh">
  <div class="header">
    <span>
      {{'common.remove_outlier' | translate}}
    </span>
  </div>
  <img src="assets/images/dialog-close.svg" class="close" alt="close" mat-dialog-close>
  @if (dataSource?.data?.length) {
    <table mat-table [dataSource]="dataSource" class="full-width-table spc-table">
      <caption></caption>
      <ng-container matColumnDef="select">
        <th mat-header-cell *matHeaderCellDef id="check">
          <mat-checkbox (change)="$event ? masterToggle() : null"
            [checked]="selection.hasValue() && isAllSelected()"
            [indeterminate]="selection.hasValue() && !isAllSelected()" [aria-label]="checkboxLabel()">
          </mat-checkbox>
        </th>
        <td mat-cell *matCellDef="let row">
          <mat-checkbox (click)="$event.stopPropagation()" (change)="$event ? selection.toggle(row) : null"
            [checked]="selection.isSelected(row)" [aria-label]="checkboxLabel(row)">
          </mat-checkbox>
        </td>
      </ng-container>
      <ng-container matColumnDef="convertedTS">
        <th mat-header-cell *matHeaderCellDef id="time"> {{'common.time' | translate}} </th>
        <td mat-cell *matCellDef="let element"> {{element.convertedTS | date:'MMM d, y, HH:mm'}} </td>
      </ng-container>
      <ng-container matColumnDef="value">
        <th mat-header-cell *matHeaderCellDef id="value"> {{'common.value' | translate}} </th>
        <td mat-cell *matCellDef="let element"> {{element.value}} </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;" (click)="selection.toggle(row)">
      </tr>
    </table>
  }

  @if (!dataSource?.data?.length) {
    <div class="no-data">
      {{'common.remove_outlier_msg' | translate}}.
    </div>
  }

  <div class="text-align-center btn-wrapper">
    <button mat-raised-button class="spc-btn" [disabled]="!selection?.selected?.length" color="primary"
      (click)="submit()" type="submit">
      {{'common.submit_cap' | translate}}
    </button>
  </div>
</div>